import { memo } from 'react';
import { useModal, ModalType, type ModalPropsMap } from '../../lib/modal';
import { AddressModal } from './AddressModal';
import { AuthModal } from './AuthModal';
import { RegistrationModal } from './RegistrationModal';
import { BankAccountFormModal } from './BankAccountFormModal';
import { ProductDetailModal } from './ProductDetailModal';

export const ModalRenderer = memo(() => {
  const { modalState } = useModal();

  if (!modalState.type) return null;

  switch (modalState.type) {
    case ModalType.ADDRESS_MODAL: {
      const props = modalState.props as ModalPropsMap[ModalType.ADDRESS_MODAL];
      return <AddressModal onSave={props.onSave} />;
    }

    case ModalType.AUTH_MODAL:
      return <AuthModal />;

    case ModalType.REGISTRATION_MODAL: {
      const props = modalState.props as ModalPropsMap[ModalType.REGISTRATION_MODAL];
      return <RegistrationModal userEmail={props?.userEmail} />;
    }

    case ModalType.BANK_ACCOUNT_FORM_MODAL: {
      const props = modalState.props as ModalPropsMap[ModalType.BANK_ACCOUNT_FORM_MODAL];
      return <BankAccountFormModal onSubmit={props.onSubmit} isProcessing={props.isProcessing} />;
    }

    case ModalType.PRODUCT_DETAIL: {
      const props = modalState.props as ModalPropsMap[ModalType.PRODUCT_DETAIL];
      return <ProductDetailModal product={props.product} />;
    }

    case ModalType.CART_DRAWER:
      // Cart drawer is rendered globally, not through modal system
      return null;

    default:
      return null;
  }
});

ModalRenderer.displayName = 'ModalRenderer';
